import styled from 'styled-components';

import { Body2, Caption, colors, fontWeights, H4, spacing } from 'ui/theme';

export const ScoreDataContainer = styled.div`
  display: flex;
  align-items: center;
`;

/** Score Text */
export const ScoreAndDateContainer = styled.div`
  display: flex;
  align-items: center;
`;

const scoreStyle = `
  margin-top: 0;
  margin-bottom: 0;
  &[data-current-score="true"] {
    margin-right: ${spacing.half};
  }
  &[data-current-score="false"] {
    margin-right: ${spacing.quarter};
  }
`;
export const ScoreHeader = styled(H4)`
  font-weight: ${fontWeights.bold};
  ${scoreStyle}
`;
export const ScoreBody = styled(Body2)`
  font-weight: ${fontWeights.regular};
  ${scoreStyle}
`;

/** Score Dates */
export const TimestampText = styled(Caption)<{ date: string }>`
  align-self: flex-end;
  color: ${colors.textDisabled};
`;

export const AffinityHistoryContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

/** Score Icon */
export const ColoredPieContainer = styled.div`
  display: flex;
  align-items: center;
  margin-right: ${spacing.threeQuarter};
`;

export const ScoreDescription = styled(Body2)`
  color: ${colors.textSecondary};
  margin-top: ${spacing.half};
`;

export const SkeletonContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const HeaderText = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: ${spacing.eighth};
`;

export const BodyRow = styled.div`
  display: flex;
  align-items: center;
`;
